<script>
export default {
  name: 'MaterialAvatar',
  props: {
    item: Object,
  },
  computed: {
    image() {
      const file = this.avatar;
      return file?.thumbnails?.avatar || file?.url || '';
    },
  },
};
</script>

<template lang="pug">
.material-avatar
  img._image(v-if="avatar" :src="image")
  ._placeholder(v-else :class="placeholder")
    Icon(:name="placeholder ? placeholder : 'no-avatar'")
  ._actions-tile(v-if="editable")
    ._actions-wrap
      label._action
        input(type="file" hidden @change="upload")
        Icon(name="upload-white-sm")
        | Загрузить фото
      ._action(v-if="avatar" @click="deleteImage")
        Icon(name="delete-white-sm")
        | Удалить
</template>

<script>
import fileApi from '@/api/file';

export default {
  name: 'AvatarEditable',

};
</script>

<style scoped lang="scss">
.avatar-editable {
  width: 184px;
  height: 184px;
  position: relative;
  border-radius: 30%;
  border: 5px solid #ffffff;
  box-shadow: 0 2px 10px 1px rgb(0 0 0 / 16%);
  overflow: hidden;
  background: #fff;

  &.gray {
    filter: grayscale(1);
  }

  &__image {
    object-fit: cover;
    //box-sizing: border-box;
    //border-radius: 30%;
    //border: 5px solid #ffffff;
    //box-shadow: 0 2px 10px 1px rgb(0 0 0 / 16%);
  }

  &__placeholder {
    background: var(--color-purple);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    //box-sizing: border-box;
    //box-shadow: 0 2px 10px 1px rgb(0 0 0 / 16%);
    //border-radius: 30%;
    //border: 5px solid #ffffff;

    svg {
      width: 45%;
      height: auto;
    }

    &.no-avatar-project {
      background: #D3EAFF;

      svg {
        width: 75%;
      }
    }
  }

  &__error {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 30px;
    background: rgba(255, 255, 255, 0.85);
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.01em;
    color: #1E3147;
    z-index: 10;
  }

  &:hover &__actions-tile {
    top: calc(100% - 65px);
  }
  &__actions-tile {
    position: absolute;
    transition: top .35s ease-in-out;
    top: 100%;
    left: 0;
    right: 0;
    height: 65px;
    background: rgba(0,0,0, .7);
    box-sizing: border-box;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 20;
  }

  &__actions-wrap {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  &__action {
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.01em;
    cursor: pointer;
    display: flex;
    gap: 7px;
    align-items: center;
  }
}
</style>
